import connection from './connection.js'


const create = async function (params, callback) {
  const url = '/admin/goods/tax/add'
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const list = async function (page,per_page,callback) {
  const url = '/admin/goods/tax/list'
  let {
    error,
    data
  } = await connection.query(url,{
    page: page,
    per_page: per_page
  })
  if (callback) callback(error, data)
}

const queryPullDown_list = async function (callback) {
const url = '/admin/goods/tax/list'
let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

const detail = async function (id,callback) {
  const url = '/admin/goods/tax/detail/' + id
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

const deleteRow = async function (id,callback) {
  const url = `/admin/goods/tax/delete/${id}`
  let {
    error,
    data
  } = await connection.update(url)
  if (callback) callback(error, data)
}

const edit = async function (id,params,callback) {
  const url = `/admin/goods/tax/update/${id}`
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}


export default {
queryPullDown_list:queryPullDown_list,
  create: create,
  list: list,
  deleteRow: deleteRow,
  detail: detail,
  edit:edit

}
